import { LoopbackFilter } from '..';

/**
 * returns query param like so
 * '?filter=*&locale=*&query=*'
 */
// eslint-disable-next-line import/prefer-default-export
export function constructQueryParams(
  filter?: LoopbackFilter, query?: string, locale?: string,
): string {
  let queryParams = '';
  if (filter || query || locale) {
    queryParams = '?';
  }
  if (filter) {
    const encodedFilter = encodeURIComponent(JSON.stringify(filter));
    queryParams = `${queryParams}filter=${encodedFilter}`;
  }
  if (query) {
    if (queryParams.length > 1) {
      queryParams = queryParams.concat('&');
    }
    queryParams = `${queryParams}query=${query}`;
  }
  if (locale) {
    if (queryParams.length > 1) {
      queryParams = queryParams.concat('&');
    }
    queryParams = `${queryParams}locale=${locale}`;
  }
  return queryParams;
}
